module.exports = __webpack_public_path__ + "static/media/add.126d5be0.svg";